import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import CreateTemplateRequestView from '@/vacancy_request/views/create-template-request';
import EditTemplateRequest from '@/vacancy_request/views/edit-template-request';
import ViewTemplateRequest from '@/vacancy_request/views/view-template-request';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorMessage } from '@components/v1/ErrorMessage';
import { useTranslationWithPrefix } from '@/i18n/hooks';
import ApplicationFormPage from '@/vacancy_request/views/application-form-page';
import { FORM_REQUEST_MODE } from '@/vacancy_request/constants/form-request-mode';
import { CollaborativeSelection } from '@/vacancy_request/views/collaborative-selection';

const GlobalStyle = createGlobalStyle`
  html {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  body {
    background-color: #f4f4f4;
    margin: 0;
  }
`;

export const RequestRouter = ({ aliasAccount, IntercomProductTourId, bannerShow, templateLinkUnavailable, editLinkUnavailable }) => {
  const { t } = useTranslationWithPrefix('requestVacancies.requestTemplate.form');

  return (
    <Router>
      <GlobalStyle />
      <Routes>
        <Route
          path='/app/vacancy_request'
          element={<CollaborativeSelection IntercomProductTourId={IntercomProductTourId} bannerShow={bannerShow} />}
        />
        <Route
          path='/app/vacancy_request/showPublicVacancyRequest/:requisitionHash'
          element={<ApplicationFormPage aliasAccount={aliasAccount} mode={FORM_REQUEST_MODE.PUBLIC_READ_ONLY} />}
        />
        <Route
          path='/app/vacancy_request/form_request/:idRequisition/view'
          element={<ApplicationFormPage aliasAccount={aliasAccount} mode={FORM_REQUEST_MODE.INTERNAL_READ_ONLY} />}
        />
        <Route
          path='/app/vacancy_request/form_request/:idRequisition/edit/:hash'
          element={
            <ApplicationFormPage
              aliasAccount={aliasAccount}
              mode={FORM_REQUEST_MODE.EDIT}
              editLinkUnavailable={editLinkUnavailable}
            />
          }
        />
        <Route
          path='/app/vacancy_request/create/:hash'
          element={<ApplicationFormPage aliasAccount={aliasAccount} mode={FORM_REQUEST_MODE.CREATE} />}
        />
        <Route
          path='/app/vacancy-request-form-links/:hash/vacancy-requests/new'
          element={
            <ApplicationFormPage
              aliasAccount={aliasAccount}
              mode={FORM_REQUEST_MODE.TEMPLATE_CREATE}
              templateLinkUnavailable={templateLinkUnavailable}
            />
          }
        />
        <Route
          path='/app/vacancy_request/template'
          element={
            <>
              <ErrorBoundary fallback={<ErrorMessage icon='hr-Alert' message={t('messages.error.general')} />}>
                <CreateTemplateRequestView />
              </ErrorBoundary>
            </>
          }
        />
        <Route
          path='/app/vacancy_request/template/:id'
          element={
            <>
              <ErrorBoundary fallback={<ErrorMessage icon='hr-Alert' message={t('messages.error.general')} />}>
                <ViewTemplateRequest />
              </ErrorBoundary>
            </>
          }
        />
        <Route
          path='/app/vacancy_request/template/:id/edit'
          element={
            <ErrorBoundary fallback={<ErrorMessage icon='hr-Alert' message={t('messages.error.general')} />}>
              <EditTemplateRequest />
            </ErrorBoundary>
          }
        />
      </Routes>
    </Router>
  );
};

RequestRouter.propTypes = {
  aliasAccount: PropTypes.string.isRequired,
  IntercomProductTourId: PropTypes.string,
  bannerShow: PropTypes.bool,
  templateLinkUnavailable: PropTypes.bool,
  editLinkUnavailable: PropTypes.bool
};

RequestRouter.defaultProps = {
  IntercomProductTourId: undefined,
  bannerShow: false,
  templateLinkUnavailable: false,
  editLinkUnavailable: false
};
